import React, { useState } from 'react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    alert('Thank you for your message! We will get back to you soon.');
    setFormData({
      name: '',
      email: '',
      subject: '',
      message: ''
    });
  };

  return (
    <section id="contact" className="contact section">
      

      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row align-items-center">
          <div className="col-lg-5" data-aos="fade-right" data-aos-delay="200">
            <div className="contact-form-card">
              <div className="form-header" data-aos="fade-up" data-aos-delay="250">
                <div className="header-icon">
                  <i className="bi bi-chat-dots-fill"></i>
                </div>
                <h3>Let's Start a Conversation</h3>
                <p>Share your goals, timeline, and tech constraints. We'll outline options, ballpark effort, and how we can support you.</p>
              </div>

              <form onSubmit={handleSubmit} className="php-email-form">
                <div className="row">
                  <div className="col-md-6 mb-3" data-aos="fade-up" data-aos-delay="300">
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      placeholder="Your Name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className="col-md-6 mb-3" data-aos="fade-up" data-aos-delay="350">
                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      placeholder="Email Address"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="mb-3" data-aos="fade-up" data-aos-delay="400">
                  <input
                    type="text"
                    className="form-control"
                    name="subject"
                    placeholder="What's this about?"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-4" data-aos="fade-up" data-aos-delay="450">
                  <textarea
                    className="form-control"
                    name="message"
                    rows="4"
                    placeholder="Tell us more about your project..."
                    value={formData.message}
                    onChange={handleChange}
                    required
                  ></textarea>
                </div>

                <div className="my-3">
                  <div className="loading">Loading</div>
                  <div className="error-message"></div>
                  <div className="sent-message">Your message has been sent. Thank you!</div>
                </div>

                <button type="submit" className="submit-btn" data-aos="fade-up" data-aos-delay="500">
                  <span>Send Message</span>
                  <i className="bi bi-send-fill"></i>
                </button>
              </form>
            </div>
          </div>

          <div className="col-lg-7" data-aos="fade-left" data-aos-delay="200">
            <div className="contact-info-area">
              <div className="info-header">
                <h3>Ready to Build Something Great?</h3>
                <p>Whether you need a new app, a cloud migration, or long-term technical support, we're here to help. Reach out and we'll get back to you within one business day.</p>
              </div>

              <div className="contact-methods">
                <div className="method-card" data-aos="zoom-in" data-aos-delay="250">
                  <div className="card-icon">
                    <i className="bi bi-envelope-at"></i>
                  </div>
                  <div className="card-content">
                    <h5>Email Us</h5>
                    <p><a href="mailto:info@rettiyonglobal.com">info@rettiyonglobal.com</a></p>
                    <span className="response-time">Response in 2-4 hours</span>
                  </div>
                </div>

                <div className="method-card" data-aos="zoom-in" data-aos-delay="300">
                  <div className="card-icon">
                    <i className="bi bi-telephone"></i>
                  </div>
                  <div className="card-content">
                    <h5>Call Us</h5>
                    <p>+91 6282 392 850</p>
                    <span className="response-time">Available 9AM - 6PM IST</span>
                  </div>
                </div>

                <div className="method-card" data-aos="zoom-in" data-aos-delay="350">
                  <div className="card-icon">
                    <i className="bi bi-geo-alt"></i>
                  </div>
                  <div className="card-content">
                    <h5>Visit Our Office</h5>
                    <p>Rettiyon Global Private Limited, 3100/2013/61, Ground Floor, Manikath Road, Ravipuram, Kochi M.g.road, Ernakulam, Kerala, India, 682016</p>
                    <span className="response-time">Open Monday - Friday</span>
                  </div>
                </div>
              </div>

              <div className="additional-info" data-aos="fade-up" data-aos-delay="400">
                <div className="info-stats">
                  <div className="stat-item">
                    <div className="stat-number">24h</div>
                    <div className="stat-label">Average Response</div>
                  </div>
                  <div className="stat-item">
                    <div className="stat-number">98%</div>
                    <div className="stat-label">Client Satisfaction</div>
                  </div>
                  <div className="stat-item">
                    <div className="stat-number">150+</div>
                    <div className="stat-label">Projects Delivered</div>
                  </div>
                </div>

                <div className="social-connect">
                  <h6>Connect With Us</h6>
                  <div className="social-links">
                    <a href="#" className="social-link"><i className="bi bi-linkedin"></i></a>
                    <a href="#" className="social-link"><i className="bi bi-twitter-x"></i></a>
                    <a href="#" className="social-link"><i className="bi bi-github"></i></a>
                    <a href="#" className="social-link"><i className="bi bi-discord"></i></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
